import { clsx } from 'clsx';

export const APP_SHELL_PADDING_X =
  'px-4 sm:px-6 md:px-8 lg:px-10 xl:px-[42px]';

export const APP_SHELL_MAIN_GAP =
  'gap-3 sm:gap-4 md:gap-6 lg:gap-8 xl:gap-[72px]';

export const APP_SHELL_MAIN_PT =
  'pt-4 sm:pt-6 md:pt-8 lg:pt-10 xl:pt-[42px]';

export const ONLINE_CONTACTS_COLUMN_CLASS =
  'hidden w-[16vw] min-w-[12rem] max-w-[18rem] shrink-0 flex-col lg:flex xl:w-[14vw] xl:max-w-[18rem]';

export const ONLINE_CONTACTS_COLUMN_CLASS_FOLDED =
  'hidden w-0 min-w-0 max-w-none shrink-0 flex-col overflow-visible lg:flex';

export const ONLINE_CONTACTS_ASIDE_ANCHOR =
  'lg:sticky lg:self-start';

export const ONLINE_CONTACTS_MAIN_GAP = 'gap-2';

export const ONLINE_CONTACTS_PANEL_GUTTER = 'mt-2';

export const ONLINE_CONTACTS_PANEL_RIGHT_ALIGN =
  '-mr-[8px] sm:-mr-4 md:-mr-6 lg:-mr-8 xl:-mr-[34px]';

export const ONLINE_CONTACTS_PANEL_STICKY_TOP = 'lg:top-2';

export const ONLINE_CONTACTS_PANEL_HEIGHT = 'h-2/3 max-h-[66vh] min-h-0';

export const PAGE_HEADER_PADDING_X = APP_SHELL_PADDING_X;

export const TABLE_SCROLL_CONTAINER_CLASS = 'min-w-0 overflow-x-auto';

export const TABLE_MIN_WIDTH_COMPACT_CLASS = 'min-w-[640px] lg:min-w-0';

export const TABLE_MIN_WIDTH_CONTACTS_CLASS =
  'min-w-[560px] md:min-w-[700px] xl:min-w-0';

export const TABLE_MIN_WIDTH_STANDARD_CLASS =
  'min-w-[640px] md:min-w-[800px] lg:min-w-[980px] xl:min-w-0';

export const TABLE_MIN_WIDTH_WIDE_CLASS =
  'min-w-[640px] md:min-w-[900px] lg:min-w-[1040px] xl:min-w-0';

export const ACTIVE_CALLS_TABLE_MIN_WIDTH_CLASS =
  'min-w-[720px] lg:min-w-0';

export const VOICEMAIL_TABLE_MIN_WIDTH_CLASS =
  'min-w-[760px] lg:min-w-0';

const CARD_SHADOW =
  'shadow-[0px_20px_12px_rgba(16,24,40,0.08),0px_8px_4px_rgba(16,24,40,0.03)]';

export const CARD_SECTION_CLASS = `overflow-hidden rounded bg-white ${CARD_SHADOW}`;

export const PAGE_TITLE_CLASS = 'text-2xl font-bold leading-8 text-unilink-text-primary';

export const PAGE_SUBTITLE_CLASS = 'mt-1 text-base leading-6 text-unilink-text-primary';

export const SECTION_TITLE_CLASS = 'text-xl font-bold leading-6 text-unilink-text-primary';

export const TABLE_HEADER_CLASS =
  'pb-3 text-base font-bold leading-[22px] text-unilink-text-primary';

export const TABLE_ROW_CLASS = 'py-5 text-base leading-[22px] text-unilink-text-primary';

export const GRID_TABLE_HEADER_CLASS =
  'border-b-[0.5px] border-unilink-border-separator pb-3 text-base font-bold text-unilink-text-primary';

export const GRID_TABLE_ROW_CLASS =
  'border-b-[0.5px] border-unilink-border-separator py-5 text-base text-unilink-text-primary';

export const FILTER_FIELDS_GRID_CLASS =
  'grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4';

export const DETAIL_SECTION_TITLE_CLASS =
  'mb-4 text-base font-bold leading-[22px] text-unilink-text-primary';

export const DETAIL_FIELD_LABEL_CLASS =
  'text-base font-bold leading-[22px] text-unilink-text-primary';

export const DETAIL_FIELD_VALUE_CLASS = 'text-base leading-[22px] text-unilink-text-primary';

export const DETAIL_FIELD_INPUT_CLASS =
  'h-9 w-full rounded border border-unilink-border-outline bg-white px-3 py-1 text-base leading-[22px] text-unilink-text-primary placeholder:text-unilink-text-placeholder focus:border-blue-navbar focus:outline-none focus:ring-2 focus:ring-blue-navbar';

export const TABLE_ACTION_ICON_CLASS = 'size-3.5 text-unilink-text-primary';

export const MODAL_CLOSE_ICON_CLASS = 'size-6 text-unilink-text-primary';

export const ACTIVE_CALLS_TABLE_GRID =
  'grid w-full grid-cols-[repeat(7,minmax(0,1fr))_68px] items-center gap-x-4 md:gap-x-5 xl:gap-x-[30px]';

export const VOICEMAIL_TABLE_GRID =
  'grid w-full grid-cols-[repeat(5,minmax(0,1fr))_minmax(120px,180px)] items-center gap-x-4 md:gap-x-5 xl:gap-x-[30px]';

export const NOMINAL_VOICEMAIL_TABLE_GRID =
  'grid w-full grid-cols-[minmax(0,1fr)_minmax(0,1.2fr)_minmax(4.5rem,0.7fr)_216px] items-center gap-x-4 md:gap-x-5';

export const VOICEMAIL_ACTIONS_CELL_CLASS =
  'flex w-full items-center justify-end gap-3';

export const ADDRESS_BOOK_TABLE_HEADER_CLASS =
  'border-b border-unilink-text-muted pb-3 text-base font-bold text-unilink-text-primary';

export const ADDRESS_BOOK_TABLE_ROW_CLASS =
  'border-b border-unilink-border-table py-5 text-base text-unilink-text-primary';

export const ADDRESS_BOOK_STATUS_CELL_CLASS = 'flex justify-end text-right';

export const MANAGEMENT_ACCOUNTS_TABLE_GRID =
  'grid w-full grid-cols-[minmax(8rem,2fr)_minmax(5rem,1fr)_minmax(6rem,1.5fr)_minmax(5rem,1fr)_repeat(4,minmax(3.25rem,4rem))] items-center gap-x-4 md:gap-x-5';

export const MANAGEMENT_ACCOUNTS_TABLE_MIN_WIDTH = 'w-full min-w-[56rem]';

export const MANAGEMENT_ACCOUNTS_TOGGLE_HEADER_CLASS =
  'block w-full text-center text-base font-bold';

export const MANAGEMENT_ACCOUNTS_TOGGLE_CELL_CLASS =
  'flex w-full min-w-0 items-center justify-center';

export const PANEL_SEPARATOR_B = 'border-b-[0.5px] border-unilink-border-separator';
export const PANEL_SEPARATOR_T = 'border-t-[0.5px] border-unilink-border-separator';

function panelListRowTopBorder(isFirst: boolean): string {
  return isFirst ? '' : PANEL_SEPARATOR_T;
}

export const DASHBOARD_CALL_HISTORY_ROW_HEIGHT_PX = 69;

export function getCallHistoryRowClassName(
  isFirst: boolean,
  hasRecordingLink: boolean
): string {
  return clsx(
    'px-5',
    hasRecordingLink ? 'pb-[10px] pt-[15px]' : 'py-[15px]',
    panelListRowTopBorder(isFirst)
  );
}

export const MODAL_OVERLAY_CLASS =
  'fixed inset-0 z-50 flex items-start justify-center bg-black/60 px-4 py-8';

export const MODAL_PANEL_CLASS =
  `flex max-h-[90vh] w-full flex-col overflow-hidden rounded bg-white ${CARD_SHADOW}`;

export const MODAL_HEADER_CLASS = clsx(
  'flex items-center justify-between px-8 py-6',
  PANEL_SEPARATOR_B
);

export const MODAL_BODY_CLASS = 'px-8 py-6';

export const MODAL_FOOTER_CLASS = 'flex justify-end gap-3 px-8 pb-8';

export const PAGE_INITIAL_LOADING_CLASS =
  'flex flex-1 items-center justify-center bg-white';

export const INLINE_LOADING_CLASS = 'flex justify-center py-12';

export const TIME_INPUT_CONTAINER_CLASS = 'w-[8.25rem] shrink-0';

export const COMMON_CLASSES = {
  input:
    'w-full h-11 px-3.5 text-base text-unilink-text-primary border border-unilink-border-outline rounded bg-white placeholder:text-unilink-text-placeholder focus:outline-none focus:ring-2 focus:ring-blue-navbar focus:border-blue-navbar',
  inputError: 'border-red-500 focus:ring-red-500 focus:border-red-500',
  select:
    'w-full h-11 px-3.5 text-base text-unilink-text-primary border border-unilink-border-outline rounded bg-white focus:outline-none focus:ring-2 focus:ring-blue-navbar focus:border-blue-navbar',
  filterSelect:
    'h-[44px] w-full rounded border border-unilink-border-outline px-3.5 text-base text-unilink-text-primary',
  label: 'block text-base font-semibold leading-5 text-unilink-text-primary mb-1.5',
  button:
    'inline-flex items-center justify-center font-semibold rounded focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors',
  buttonPrimary: 'bg-blue-navbar text-white hover:opacity-90 focus:ring-blue-navbar',
  buttonSecondary:
    'bg-white text-unilink-text-primary border-[1.5px] border-unilink-border-outline hover:bg-unilink-surface-hover focus:ring-gray-400',
  buttonDanger: 'bg-unilink-danger text-white hover:opacity-90 focus:ring-red-500',
  buttonGhost:
    'text-unilink-text-primary hover:bg-unilink-surface-hover focus:ring-gray-400',
  errorMessage: 'bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded',
  grid2Col: 'grid grid-cols-1 md:grid-cols-2 gap-4',
  textError: 'text-sm text-red-600',
  textHelper: 'text-sm text-gray-500',
} as const;

export const SIZE_CLASSES = {
  button: {
    sm: 'h-8 px-3 text-sm leading-5',
    md: 'h-10 px-5 text-base leading-6',
    lg: 'h-11 px-6 text-base leading-6',
  },
  spinner: {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16',
  },
} as const;
